const initialState = {
  viewer: {
    isAuthenticated: false,
    userName: '',
    errorCode: '',
    profile: {},
  },
  statusText: '',
};

export default initialState;
